import "./Css/ExamManagment.css";
import axios from "axios";
import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_BASE from "../config/api";

const ExamManagement = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [examList, setExamList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const [hasSoftwareAccess, setHasSoftwareAccess] = useState(true);

  const [cards, setCards] = useState({
    upcoming: 0,
    ongoing: 0,
    completed: 0
  });

  const handleDeleteClick = (paperId) => {
    setDeleteIndex(paperId); // now storing paperId
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(
        `${API_BASE}/api/Papers/${deleteIndex}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      // Remove from UI
      await loadPapers();

      setShowDeletePopup(false);
      setDeleteIndex(null);

    } catch (err) {
      console.error("Delete Error:", err.response?.data);
    }
  };


  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };
  const handleViewClick = (index) => {
    navigate("/dashboard/examview");
  };
  const handleEditClick = (index) => {
    navigate("/dashboard/examedit");
  };

  const filteredData = examList;


  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const location = useLocation();

  useEffect(() => {
    // 1️⃣ Publish exam logic (status update)
    if (location.state?.publishedExamId) {
      setExamList(prev =>
        prev.map(exam =>
          exam.id === location.state.publishedExamId
            ? {
              ...exam,
              status: "चालू परीक्षा",
              date: location.state.examDate || exam.date,
              time: location.state.examTime || exam.time,
            }
            : exam
        )
      );
    }

    if (location.state?.publishedResultExamId) {
      setExamList(prev =>
        prev.filter(
          exam => exam.id !== location.state.publishedResultExamId
        )
      );
    }
  }, [location.state]);


  const loadPapers = async () => {
    if (!hasSoftwareAccess) return;
    try {
      const res = await axios.get(`${API_BASE}/api/Papers/institute/all`, {
        params: {
          PageNumber: currentPage,
          PageSize: rowsPerPage,
          Search: searchQuery || null,
          SoftwareId: selectedSoftware || null,
          StandardId: selectedStandard || null,
          SubjectId: selectedSubject || null
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`

        }
      });

      const data = res.data;

      setExamList(
        data.data.map(x => ({
          id: x.id,
          name: x.softwareName,
          type: x.paperType,
          standard: x.standardName,
          subject: x.subjectName,
          date: x.paperDate
            ? new Date(x.paperDate).toLocaleDateString("en-GB")
            : "-",
          time: x.paperStartTime ?? "-",
          duration:
            x.paperStartTime && x.paperEndTime
              ? `${Math.round(
                (new Date("1970-01-01T" + x.paperEndTime) -
                  new Date("1970-01-01T" + x.paperStartTime)) /
                60000
              )} मिनिटे`
              : "-",
          questions: x.totalQuestions,
          marks: x.marks,
          status:
            x.paperStatus === 1
              ? "परीक्षा जाहीर करा"
              : x.paperStatus === 2
                ? "चालू परीक्षा"
                : "निकाल जाहीर करा"
        }))
      );

      setTotalRecords(data.totalRecords);
    } catch (err) {
      console.error(err);
    }
  };

  const loadDropdowns = async (softwareId, standardId) => {
    try {
      const res = await axios.get(`${API_BASE}/api/Papers/institute/dropdowns`, {
        params: {
          softwareId,
          standardId
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`

        }
      });

      setSoftwares(res.data.softwares);
      setStandards(res.data.standards);
      setSubjects(res.data.subjects);
    } catch (err) {
      console.error(err);
    }
  };

  const loadCards = async (softwareId) => {
    if (!softwareId) return; // prevent empty call

    try {
      const res = await axios.get(
        `${API_BASE}/api/Papers/dashboard-cards/${softwareId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      setCards({
        upcoming: res.data.upcomingExams,
        ongoing: res.data.ongoingExams,
        completed: res.data.completedExams
      });

    } catch (err) {
      console.error("Dashboard Cards Error:", err.response?.data);
    }
  };


  useEffect(() => {
    loadPapers();
  }, [currentPage, rowsPerPage, searchQuery, selectedSoftware, selectedStandard, selectedSubject]);

  useEffect(() => {
    loadDropdowns(selectedSoftware, selectedStandard);
  }, [selectedSoftware, selectedStandard]);

  useEffect(() => {
    if (selectedSoftware) {
      loadCards(selectedSoftware);
    }
  }, [selectedSoftware]);


  if (!hasSoftwareAccess) {
    return (
      <div className="qb-container">
        <div style={{ textAlign: "center", padding: "80px" }}>

          <img
            src="/group.png"
            alt="No Software"
            style={{ width: "300px", marginBottom: "20px" }}
          />

          <h2>आपण अजून AKES सॉफ्टवेअर खरेदी केलेले नाही ?</h2>

          <p style={{ color: "#777", marginTop: "10px" }}>
            आपल्या विद्यार्थ्यांच्या विशेष तयारीसाठी सॉफ्टवेअर उपलब्ध आहे.
            आजच नोंदणी करून आपल्या संस्थेसाठी योग्य सॉफ्टवेअर निवडा.
          </p>

          <button
            className="primary-btn"
            style={{ marginTop: "20px" }}
            onClick={() => navigate("/dashboard/softwarepurchase")}
          >
            आता नोंदणी करा
          </button>

        </div>
      </div>
    );
  }


  return (
    <div className="exam-page">
      {/* Header */}
      <div className="exam-header">
        <h3>परीक्षा व्यवस्थापन</h3>
        <button className="primary-btn" onClick={() => navigate("/dashboard/createexam")}>परीक्षा तयार करा</button>
      </div>
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
      </div>


      {/* Stats */}
      <div className="stat">
        <div className="stat purple">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
            <path d="M22.4987 22.6925C23.5073 22.6925 24.3844 22.3767 25.1299 21.745C25.8758 21.1136 26.2487 20.3183 26.2487 19.3592H32.4987V7.6925C32.4987 7.43583 32.3919 7.20069 32.1783 6.98708C31.9647 6.77347 31.7295 6.66667 31.4729 6.66667H13.5245C13.2679 6.66667 13.0327 6.77347 12.8191 6.98708C12.6055 7.20069 12.4987 7.43583 12.4987 7.6925V19.3592H18.7487C18.7487 20.3183 19.1231 21.1136 19.872 21.745C20.6209 22.3767 21.4965 22.6925 22.4987 22.6925ZM13.5245 28.3333C12.7573 28.3333 12.1168 28.0764 11.6029 27.5625C11.089 27.0486 10.832 26.4081 10.832 25.6408V7.6925C10.832 6.92528 11.089 6.28472 11.6029 5.77083C12.1168 5.25694 12.7573 5 13.5245 5H31.4729C32.2401 5 32.8806 5.25694 33.3945 5.77083C33.9084 6.28472 34.1654 6.92528 34.1654 7.6925V25.6408C34.1654 26.4081 33.9084 27.0486 33.3945 27.5625C32.8806 28.0764 32.2401 28.3333 31.4729 28.3333H13.5245ZM8.52453 33.3333C7.75731 33.3333 7.11675 33.0764 6.60286 32.5625C6.08898 32.0486 5.83203 31.4082 5.83203 30.6413V11.0258H7.4987V30.6413C7.4987 30.8976 7.6055 31.1326 7.81911 31.3463C8.03273 31.5599 8.26786 31.6667 8.52453 31.6667H28.1395V33.3333H8.52453Z" fill="#8D62EE" />
          </svg></div>
          <div>
            <h4>एकूण परीक्षा</h4>
            <p>{totalRecords}</p>
          </div>
        </div>
        <div className="stat green">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 30 27" fill="none">
            <path d="M2.6925 26.6025C1.92528 26.6025 1.28472 26.3456 0.770833 25.8317C0.256944 25.3178 0 24.6772 0 23.91V17.6283C0 16.8611 0.256944 16.2206 0.770833 15.7067C1.28472 15.1928 1.92528 14.9358 2.6925 14.9358H8.71792C9.08125 16.4103 9.84514 17.6122 11.0096 18.5417C12.174 19.4711 13.5042 19.9358 15 19.9358C16.5383 19.9358 17.8899 19.4711 19.0546 18.5417C20.219 17.6122 20.9615 16.4103 21.2821 14.9358H27.3075C28.0747 14.9358 28.7153 15.1928 29.2292 15.7067C29.7431 16.2206 30 16.8611 30 17.6283V23.91C30 24.6772 29.7431 25.3178 29.2292 25.8317C28.7153 26.3456 28.0747 26.6025 27.3075 26.6025H2.6925ZM24.0129 11.0767L22.8333 9.8975L27.5963 5.13459L28.7758 6.31417L24.0129 11.0767ZM5.98708 11.0767L1.22417 6.31417L2.40375 5.13459L7.16667 9.8975L5.98708 11.0767ZM14.1667 6.66667V0H15.8333V6.66667H14.1667Z" fill="#4A9A9A" />
          </svg></div>
          <div>
            <h4>आगामी परीक्षा</h4>
            <p>{cards.upcoming}</p>
          </div>
        </div>
        <div className="stat blue">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 40 40" fill="none">
            <path d="M19.9367 33.3307C16.5522 33.3307 13.6019 32.2255 11.0858 30.0149C8.56972 27.8046 7.11403 25.021 6.71875 21.6641H8.40458C8.85764 24.5316 10.1638 26.9152 12.3229 28.8149C14.4821 30.7143 17.02 31.6641 19.9367 31.6641C23.1867 31.6641 25.9436 30.5321 28.2075 28.2682C30.4714 26.0043 31.6033 23.2474 31.6033 19.9974C31.6033 16.7474 30.4714 13.9905 28.2075 11.7266C25.9436 9.46267 23.1867 8.33073 19.9367 8.33073C18.2122 8.33073 16.5915 8.69503 15.0746 9.42365C13.5574 10.1523 12.2186 11.1555 11.0583 12.4332H15.1933V14.0999H8.27V7.17698H9.93667V11.1578C11.2253 9.74309 12.7354 8.64045 14.4671 7.8499C16.199 7.05934 18.0222 6.66406 19.9367 6.66406C21.785 6.66406 23.5174 7.01184 25.1337 7.70739C26.7501 8.40295 28.1625 9.3549 29.3708 10.5632C30.5792 11.7716 31.5311 13.1839 32.2267 14.8003C32.9222 16.4167 33.27 18.1491 33.27 19.9974C33.27 21.8457 32.9222 23.5781 32.2267 25.1945C31.5311 26.8109 30.5792 28.2232 29.3708 29.4316C28.1625 30.6399 26.7501 31.5918 25.1337 32.2874C23.5174 32.983 21.785 33.3307 19.9367 33.3307ZM25.2767 26.4203L19.1996 20.3436V11.6641H20.8662V19.6511L26.4558 25.2411L25.2767 26.4203Z" fill="#4BA3E0" />
          </svg></div>
          <div>
            <h4>मागील परीक्षा</h4>
            <p>{cards.completed}</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>परीक्षेचे नाव</th>
              <th>परीक्षा प्रकार </th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>परीक्षेची तारीख</th>
              <th>वेळ</th>
              <th>कालावधी</th>
              <th>एकूण गुण</th>
              <th>परीक्षा स्थिती</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((exam, index) => (
              <tr key={exam.id}>
                <td>{index + 1}</td>
                <td>{exam.name}</td>
                <td>{exam.type}</td>
                <td>{exam.standard}</td>
                <td>{exam.subject}</td>
                <td>{exam.date}</td>
                <td>{exam.time}</td>
                <td>{exam.duration}</td>
                <td>{exam.marks}</td>
                <td>
                  <span
                    className={`status ${exam.status === "चालू परीक्षा"
                      ? "greenn"
                      : exam.status === "परीक्षा जाहीर करा"
                        ? "redn clickable"
                        : exam.status === "निकाल जाहीर करा"
                          ? "bluen clickable"
                          : ""
                      }`}
                    onClick={() => {
                      if (exam.status === "परीक्षा जाहीर करा") {
                        navigate("/dashboard/publishpaper", {
                          state: { examId: exam.id },
                        });
                      }

                      if (exam.status === "निकाल जाहीर करा") {
                        navigate("/dashboard/resulttabel", {
                          state: { examId: exam.id },
                        });
                      }
                    }}
                  >
                    {exam.status}
                  </span>

                </td>

                <td className="actions">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(index)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEditClick(index)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(exam.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7.6155 20.0036C7.15517 20.0036 6.77083 19.8495 6.4625 19.5411C6.15417 19.2328 6 18.8485 6 18.3881V6.00363H5V5.00363H9V4.23438H15V5.00363H19V6.00363H18V18.3881C18 18.8485 17.8458 19.2328 17.5375 19.5411C17.2292 19.8495 16.8448 20.0036 16.3845 20.0036H7.6155ZM9.80775 17.0036H10.8078V8.00363H9.80775V17.0036ZM13.1923 17.0036H14.1923V8.00363H13.1923V17.0036Z" fill="#FF1501" />
                  </svg>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box delete-confirm-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
                <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000" />
              </svg>
              <h3>डिलेक्ट करा</h3>
              <p>तुम्हाला हि परीक्षा डिलेक्ट करायची आहे का?</p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button className="delete-confirm-btn" onClick={confirmDelete}>होय </button>
            </div>
          </div>
        </div>
      )}
      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamManagement;
